import React from 'react';
import { SignupForm } from './SignupForm';
type NewsletterBandProps = {
  source?: string;
};
export function NewsletterBand({
  source = 'twelve_letter'
}: NewsletterBandProps) {
  return <section aria-labelledby={`${source}-letter-title`} className="dusk-field" data-id="element-315" data-mp="2k6s5mwo0fo7z">
      <div className="gutter grid gap-12 py-[clamp(4rem,8vw,9rem)] lg:grid-cols-[minmax(0,1fr)_minmax(0,1.5fr)] lg:items-end lg:gap-[clamp(3rem,6vw,9rem)]" data-id="element-316" data-mp="2g5ope921vq68">
        <div data-id="element-317" data-mp="2b86s5fxeaze2">
          <p className="t-label text-graphite" data-id="element-318" data-mp="2b7wxhf1eo421">The Twelve Letter</p>
          <h2 id={`${source}-letter-title`} className="t-h2 mt-5 max-w-[14ch]" data-id="element-319" data-mp="266hhi1e34nqi">
            Timing for the weeks ahead.
          </h2>
          <p className="t-lead mt-6 max-w-[46ch] text-graphite" data-id="element-320" data-mp="21ailbrmim1fj">
            Timing, transits and rituals for the weeks ahead, plus first access to new pieces and reading openings. Every couple of weeks.
          </p>
        </div>
        <SignupForm source={source} data-id="element-321" data-mp="3rl52ziie420l" />
      </div>
    </section>;
}